<template>
  <div class="page-fixed">
    <van-swipe
      class="my-swipe"
      :loop="false"
      :show-indicators="false"
      @change="onChange"
    >
      <van-swipe-item v-for="(item, index) in dataList" :key="index">
        <detail-page
          :item="item"
          :index="nowIndex"
          :dataleng="dataList.length"
        ></detail-page>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import DetailPage from '../components/detail'
export default {
  components: { DetailPage },
  data() {
    return {
      nowIndex: 1,
      dataList: [
        {
          title: '大会上看到看手机看的是空间都是的哈里看见的拉动',
          source: '北京国际服务贸易中心',
          data: '',
          img:
            'https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3252521864,872614242&fm=26&gp=0.jpg',
          content:
            '当今世界第三季度老实交代第三季度老是奇偶的搜都是为了电视剧的历史的老师觉得老师的'
        },
        {
          title: '大会上看到看手机看的是空间都是的哈里看见的拉动',
          source: '北京国际服务贸易中心',
          data: '',
          img:
            'https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1035415831,1465727770&fm=26&gp=0.jpg',
          content:
            '当今世界第三季度老实交代第三季度老是奇偶的搜都是为奇偶的搜都是为了电视剧的历史的老师觉得老师的了电视剧的历史的老师觉得老师的'
        },
        {
          title: '大会上看到看手机看的是空间都是的哈里看见的拉动',
          source: '北京国际服务贸易中心',
          data: '',
          img:
            'https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2655187787,853283011&fm=26&gp=0.jpg',
          content: '当今世界第三季度老实交代第三季度老是奇偶的'
        },
        {
          title: '大会上看到看手机看的是空间都是的哈里看见的拉动',
          source: '北京国际服务贸易中心',
          data: '',
          img:
            'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1593429664151&di=0946fafa8555a971bd9265cb9abc2aa3&imgtype=0&src=http%3A%2F%2Fa0.att.hudong.com%2F56%2F12%2F01300000164151121576126282411.jpg',
          content:
            '当今世界第三季度老实交代第三季度老是奇偶的搜都是为了电视剧的历史的老师觉得老师的'
        }
      ]
    }
  },
  mounted() {},
  methods: {
    onChange(index) {
      this.nowIndex = index += 1
    }
  }
}
</script>

<style lang="scss" scoped>
.my-swipe,
.van-swipe-item {
  width: 100%;
  height: 100%;
}
</style>
